var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBookIconHitachi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 16.9649C11.5 17.1447 11.4585 17.322 11.3787 17.4831C11.2989 17.6442 11.1829 17.7847 11.0399 17.8935C10.8968 18.0024 10.7305 18.0768 10.554 18.1108C10.3775 18.1448 10.1955 18.1375 10.0222 18.0896L1.85556 15.8208C1.61007 15.7529 1.39356 15.6065 1.23907 15.404C1.08459 15.2015 1.00063 14.954 1 14.6992V2.16691C0.999962 1.98714 1.04147 1.80979 1.12128 1.6487C1.2011 1.48762 1.31706 1.34716 1.46012 1.23828C1.60317 1.12941 1.76946 1.05507 1.94599 1.02106C2.12251 0.987056 2.30451 0.994307 2.47778 1.04225L10.6444 3.67969C10.8903 3.74772 11.1071 3.89446 11.2616 4.09745C11.4162 4.30043 11.4999 4.54847 11.5 4.80358V16.9649Z",
    stroke: "#A2201C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.16675 1.00027H13.8334C14.1428 1.00027 14.4396 1.12319 14.6584 1.34198C14.8772 1.56078 15.0001 1.85752 15.0001 2.16694V14.4169C15.0001 14.7264 14.8772 15.0231 14.6584 15.2419C14.4396 15.4607 14.1428 15.5836 13.8334 15.5836H11.5001",
    stroke: "#A2201C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBookIconHitachi);
export default __webpack_public_path__ + "static/media/bookIcon-hitachi.fcebca21bad619c493a87896604254eb.svg";
export { ForwardRef as ReactComponent };